import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextTypography as TYPOGRAPHY } from '@wix/wix-ui-tpa/cssVars';
import { DataHooks } from './consts';
import { classes, st } from './PageTitle.st.css';
import pageSettingsParams from '../../pageSettingsParams';
import pageStylesParams from '../../pageStylesParams';

export const PageTitle: FC = () => {
  const settings = useSettings();
  const styles = useStyles();
  const { isMobile } = useEnvironment();

  const isVisible = styles.get(pageStylesParams._pageTitleDisplay);
  if (!isVisible) {
    return null;
  }

  const tagName = settings.get(pageSettingsParams.pageTitleTagName);

  return (
    <div
      data-hook={DataHooks.WRAPPER}
      className={st(classes.root, { isMobile })}
    >
      <Text
        className={classes.title}
        data-hook={DataHooks.TITLE}
        typography={TYPOGRAPHY.largeTitle}
        tagName={tagName}
      >
        {settings.get(pageSettingsParams.pageTitleText)}
      </Text>
    </div>
  );
};
